import { useState, useEffect, useRef, useMemo } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import axios from "axios";
import { aiUrl, origin } from "../../../Config/Api-constants";
import { Base64 } from "js-base64";
import Divider from "@mui/material/Divider";
import { Box, Checkbox, CircularProgress, FormControlLabel, FormGroup, Grid, IconButton, Typography, useTheme, TextField, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import "../../../../Assets/Styles/Containers/_button.scss";
import "../../../../Assets/Styles/Containers/_inspection.scss";
import { GetUTCTime } from "../../../Helpers/GetUTCTime";
import SearchIcon from "@mui/icons-material/Search";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import PropTypes from "prop-types";
import TableHead from "@mui/material/TableHead";
import TableSortLabel from "@mui/material/TableSortLabel";
import Table from "@mui/material/Table";
import { visuallyHidden } from "@mui/utils";
import TablePagination from "@mui/material/TablePagination";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { toast } from "react-hot-toast";
import { addSelectedCommentesFromCl, addSelectedCommentesFromClNN, getCLTagsListNonNarrative, getCommentLibraryList, getCommentLibraryListNonNarrative, getCommentLibraryTagList, updateDropDownValues, UpdateTemplateDataSpecific, updateDefectData, getDefectData } from "../../../Helpers/ApiCall";
import { isHTCompanyKey } from "../../../Utils/services";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import parse from "html-react-parser";
import { cleanPayloadOnCommentLevel, } from "../../../Helpers/HelperFunctions";
import { applyDefaultRating, getTemplateRatingData, resolveRemovedDefaultRatingId } from "../../../Helpers/LineRatingUtils";
import { Tooltip } from "@mui/material";
import FilterTags from "./FilterTags";
import CommentTags from "./CommentTags";
import { clearCommentLibraryNonNarrativeListCall, clearDefaultCategories, getDefaultCategories, getInspectionDataWithOutLoader, updateCommentData } from "../../../Redux/Actions/CommonActions";
import uuid from "react-uuid";
import CommentSearch from "./CommentSearch";
import moment from "moment";
import { preprocessHTMLContent, stripLeadingPunctuationFromHtml, stripLeadingPunctuationFromPlainText, collapseFormattingWhitespace, serializeNbspEntities, normalizeDropdownPlaceholderSyntax } from "./CommentLibraryHelper";
import AddCommentModal from "./AddCommentModal";
import CommentSettings from "./CommentSettings";
import { MaskSparkle, Sparkle } from "../../../../Assets/Svg/Svg";
import AIDefectFinder from "./AIDefectFinder";
import dayjs from "dayjs"; // for timestamps

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// A narrative comment carries `comment_text` plus summary fields; this table renders
// `comment` and shows no summary at all. Ratings are flattened to Name/Color because
// that is what the rating cell reads directly.
const toNonNarrativeRow = (row) => ({
  ...row,
  comment: row?.comment_text ?? row?.comment ?? "",
  comment_dropdowns: row?.comment_dropdowns ?? [],
  ratings: (row?.ratings || []).map((item) => ({
    ...item,
    Id: item?.rating?.id ?? item?.rating?.pivot?.rating_id ?? item?.pivot?.rating_id ?? item?.Id ?? item?.id,
    Name: item?.rating?.name ?? item?.Name ?? item?.name,
    Color: item?.rating?.color ?? item?.Color ?? item?.color,
    include_in_summary: item?.rating?.include_in_summary ?? item?.include_in_summary ?? 0,
  })),
});

const NonNarrativeCL = ({
  showCommentModal,
  setShowCommentModal,
  editComment,
  setEditComment,
  templateId,
  categoryId,
  lineUuid,
  prompt,
  recommendation,
  commentUuid,
  is_mannual_prompt,
  disableCommentBtn,
  setDisableCommentBtn,
  lineName,
  categoryName,
  comment_dropdowns,
  isNarrative,
  categoryUuid,
  existingCommentUuids,
  setLineData,
  parentUuid,
  comment_input_controls,
  removed_default_rating_id,
  tags,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const storeData = useSelector((state) => state.CommonReducer);
  const [editorContent, setEditorContent] = useState({ innerHTML: " ", dropdownList: [] });
  const [commentTitle, setCommentTitle] = useState("");
  const [inspectionData, setInspectionData] = useState("");
  const [tag, setTag] = useState(tags !== undefined ? tags : []);
  const templateRatingData = getTemplateRatingData(storeData?.inspectionData?.data, templateId);
  const resolveModalRatings = () => applyDefaultRating({ removed_default_rating_id }, comment_input_controls?.find(el => el.type === "Rating")?.data, templateRatingData);
  const [ratingValue, setRatingValue] = useState(resolveModalRatings);
  const [locationValue, setLocationValue] = useState(comment_input_controls?.find(el => el.type === "Location")?.data || "");
  const [addToTemplate, setAddToTemplate] = useState(false);
  const [loader, setLoader] = useState(false);
  const [order, setOrder] = useState("asc");
  const [page, setPage] = useState(0);
  const [hasCommentLibraryData, setHasCommentLibraryData] = useState(false);
  const [search, setSearch] = useState(false);
  const [commentListData, setCommentListData] = useState([]);
  const [value, setValue] = useState(0);
  const [selectedFilterTagID, setSelectedFilterTagID] = useState([]);
  const [prefetchedNewCommentTags, setPrefetchedNewCommentTags] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
  const [initialTableData, setInitialTableData] = useState([]);
  const [hasFetchedCompanySettings, setHasFetchedCompanySettings] = useState(false);
  const [reportWriterSettingsAccess, setReportWriterSettingsAccess] = useState(null);
  const [orderBy, setOrderBy] = useState("");
  const [searchData, setSearchData] = useState("");
  const [addToLibrary, setAddToLibrary] = useState(false);
  const [selected, setSelected] = useState([]);
  const [apiPageCount, setApiPageCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [parameters, setParameters] = useState({ order: null, orderBy: null, });
  // A TREC template inside a narrative company reads the narrative comment library
  // while keeping this non-narrative UI, so its list is held locally instead of in
  // the non-narrative slice of the store.
  const isTexasNarrativeCL = Boolean(
    isHTCompanyKey() &&
    storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId)?.is_texas
  );
  const [narrativeTotalCount, setNarrativeTotalCount] = useState(0);
  // A TREC template carries its own fixed rating scheme, so the library's ratings are
  // not meaningful here and the column is dropped — but only for a narrative company,
  // where the library being read has no ratings of its own to show.
  const showRatingColumn = !(
    Boolean(storeData?.inspectionData?.data?.is_cl_narrative_company) &&
    storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId)?.is_texas
  );
  const [disable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openData, setOpenData] = useState(false)
  const [images, setImages] = useState([]);
  const [medialLibery, setMedialLibery] = useState(true);
  const [defaultSelect, setDefaultSelect] = useState("")
  const [includeRecommendation, setIncludeRecommendation] = useState(false);
  const [selectedMediaFiles, setSelectedMediaFiles] = useState([])
  const [datas, setDatas] = useState({})
  const [dataLoading, setDataLoading] = useState({})
  const [additionalInfo, setAdditionalInfo] = useState('');
  const [selectedImages, setSelectedImages] = useState([]);
  const [commentChecked, setCommentChecked] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedTone, setSelectedTone] = useState('professional');
  const [onDragtoggle, setOnDragToggle] = useState(false);
  const [tabValue, setTabValue] = useState('Short');
  const [checkbox, setCheckbox] = useState({ individually: false, prompt: false })
  const [selectedContent, setSelectedContent] = useState(null)
  const defectFinder = storeData?.defectData;

  const handleClose = () => {
    setShowCommentModal(false);
    setEditComment(false);
    setEditorContent({ innerHTML: "", dropdownList: [] });
    setCommentTitle("");
    setSelected([]);
    setCommentListData([])
    setInitialTableData([])
    setSearchData("")
    setParameters({ order: null, orderBy: null, })
    setValue(0)
    dispatch(clearCommentLibraryNonNarrativeListCall([]))
    setHasCommentLibraryData(false)
    setLoader(false);
    setSelectedFilterTagID([])
    setRatingValue([]);
    setLocationValue("");
    setTag([]);
    setAddToTemplate(false);
    setAddToLibrary(false);
    setAdditionalInfo("")
    setImages([])
    setOpenData(false)
    setIncludeRecommendation(false);
    setSelectedMediaFiles([]);
    setSelectedImages([]);
    setMedialLibery(true);
    setCommentChecked(false);
    setSelectedContent(null)
    setDefaultSelect("")
    setLoading(false)
    setDatas({})
    setCheckbox({ individually: false, prompt: false })
    setTabValue("Short")
    setDisable(false)
  };

  useEffect(() => {
    if (value === tabIndexes.aiDefectFinder && sessionStorage.getItem("comKey")) {
      fetchDefectDetails()
    }
  }, [value]);

  const toggleRowExpansion = (rowId) => {
    setExpandedRows((prevExpandedRows) => (prevExpandedRows.includes(rowId) ? prevExpandedRows.filter((id) => id !== rowId) : [...prevExpandedRows, rowId]));
  };
  const handleSelectedTone = (val) => {
    setSelectedTone(val);
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setParameters({
      order: order,
      orderBy: property,
    });
  };

  const TruncatedText = (props) => {
    const { text, expanded, fieldType, commentDropdowns, textType, rowId, rowUuid, rowDisabled } = props;
    const calculationLimit = fieldType === "title" ? 20 : fieldType === "comment_text" ? 120 : 20;
    const truncationLimit = calculationLimit * 1.1;
    const getTotalCharacterCountFromText = (text = "") => {
      if (!text) return 0;
      const values = [...text.matchAll(/value:([^;]*);?/g)].map(match => match[1]?.trim() || '');
      const plainText = text.replace(/\[textbox.*?\]/g, '');
      const valueText = values.join('');
      return valueText.length + plainText.length;
    };
    return (
      <div onClick={() => (rowDisabled ? undefined : !isRowExpanded(rowId) ? toggleRowExpansion(rowId) : undefined)}>
        {fieldType === "title" ? text : ""}
        {(expanded || getTotalCharacterCountFromText(text) <= calculationLimit) && fieldType !== "title"
          ? replacePlaceholdersWithDropdowns(text, commentDropdowns, textType, rowId, rowUuid, rowDisabled, false, truncationLimit)
          : fieldType !== "title" && replacePlaceholdersWithDropdowns(text, commentDropdowns, textType, rowId, rowUuid, rowDisabled, true, truncationLimit)}
      </div>
    );
  };

  const TruncatedTexts = ({ text, expanded, rowId, rowDisabled }) => {
    return (
      <div onClick={() => rowDisabled ? undefined : !isRowExpanded(rowId) ? toggleRowExpansion(rowId) : undefined} >
        <Typography
          sx={{
            width: "250px",
            maxWidth: "250px",
            minWidth: "250px",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-word",
            whiteSpace: expanded ? "normal" : "unset",
            WebkitLineClamp: expanded ? "unset" : 3,
          }}
        >
          {text}
        </Typography>
      </div>
    );
  };

  const handleClick = (event, id, row) => {
    event.stopPropagation();
    !isRowExpanded(id) && toggleRowExpansion(row.id);
    const selectedIndex = selected.indexOf(row.uuid);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row.uuid);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };
  const handleSelect = (name, id) => {
    const value = datas?.[name];
    setDefaultSelect(id)
    if (dataLoading[name] === true) return;
    setSelectedContent({ ...value, name: name });
  }
  const handleRetry = (val) => {
    handleNext(true, val)
  };
  const handleImageUpload = (files) => {
    const remainingSlots = 10 - images.length;
    const filesToProcess = files.slice(0, remainingSlots);
    const MAX_BYTES = 500 * 1024 * 1024; // 500 MB
    const filesWithinSize = filesToProcess.filter((f) => {
      const fileObj = f instanceof File ? f : (f?.file instanceof File ? f.file : null);
      return !fileObj || (typeof fileObj.size === "number" && fileObj.size <= MAX_BYTES);
    });
    const rejectedForSize = filesToProcess.length - filesWithinSize.length;
    if (rejectedForSize > 0) {
      toast.error(`Skipped ${rejectedForSize} file(s) larger than 500 MB`);
    }
    const now = dayjs().format("YYYY-MM-DD HH:mm:ss");
    const newImages = filesWithinSize.map((f, index) => {
      const isFileObject = typeof f !== "string" && (f instanceof File || f?.file instanceof File);
      const urlString = typeof f === "string" ? f : (typeof f?.file === "string" ? f.file : null);
      const fileObj = isFileObject ? (f instanceof File ? f : f.file) : null;
      const displayName = fileObj?.name || f?.name || (urlString ? urlString.split("/").pop() : "image");
      const byteSize = fileObj?.size || f?.size || 0;
      return {
        // Media dragged from the RML quick access bar keeps its library uuid, with id
        // matching it, so the add-comment payload links the existing RML row.
        id: f?.uuid || uuid(),
        ...(f?.uuid ? { uuid: f.uuid } : {}),
        url: null,
        name: displayName,
        size: byteSize,
        type: fileObj?.type || f.type || "image/jpeg",
        edited: false,
        newUrl: null,
        online: "online",
        filetype: "image",
        localUrl: null,
        OriginUrl: null,
        created_at: now,
        editCount: 0,
        onlineUrl: null,
        orginName: null,
        thumbnail: null,
        is_deleted: 0,
        order: images.length + index + 1,
        uploaded_by: parseInt(sessionStorage.getItem("UID")) || null,
        updated_at: now,
        description: null,
        OriginlocalUrl: null,
        isOriginUploaded: true,
        file: fileObj || (urlString ? { file: urlString } : f),
        preview: urlString || fileObj || f,
      };
    });

    if (newImages.length) {
      setImages((prev) => [...prev, ...newImages]);
    }

    if (files.length > remainingSlots) {
      toast.error(`Only ${remainingSlots} images added. Maximum of 10 images allowed.`);
    }
  };

  const handleRemoveImage = (id) => {
    setImages(prev => {
      const imageToRemove = prev.find(img => img.id === id);
      if (imageToRemove) {
        URL.revokeObjectURL(imageToRemove.preview);
      }
      return prev.filter(img => img.id !== id);
    });
  };

  const handleCheckbox = (fileName, isChecked) => {
    setDatas((prev) => {
      const updatedData = { ...prev };
      if (updatedData[fileName]) {
        updatedData[fileName] = {
          ...updatedData[fileName],
          checked: isChecked
        };
      }
      return updatedData;
    });
  };

  const getPromptTemplate = (tabValue, includeRecommendation) => {
    if (defectFinder?.defect_detector_prompts?.prompt) {
      if (tabValue === 'Short' && !includeRecommendation) {
        return defectFinder?.defect_detector_prompts?.prompt?.short;
      } else if (tabValue === 'Long' && !includeRecommendation) {
        return defectFinder?.defect_detector_prompts?.prompt?.long;
      } else if (tabValue === 'Short' && includeRecommendation) {
        return defectFinder?.defect_detector_prompts?.prompt?.short_with_recommendation;
      } else if (tabValue === 'Long' && includeRecommendation) {
        return defectFinder?.defect_detector_prompts?.prompt?.long_with_recommendation;
      } else {
        return '';
      }
    } else return '';
  }

  function formatAIResponseToHTMLTitle(text) {
    if (!text) return { html: "", title: "" };
    let title = "";
    const titleMatch = text.match(/Title:\s*(.*)/i);
    if (titleMatch) {
      title = titleMatch[1].trim();
      text = text.replace(titleMatch[0], "");
    }
    return title;
  }

  function formatAIResponseToHTML(text) {
    if (!text) return "";
    text = String(text).replace(/#+|[*]{2}/g, "").replace(/<h2>.*?<\/h2>/gi, "").replace(/Title:.*(\n|$|<br\s*\/?>)/gi, "").trim();
    const firstSentence = text.split(/[!?]/)[0];
    const title = firstSentence.trim().split(/\s+/).join(" ");
    return `<p>${title}</p>`;
  }

  const getCharacterLimit = (tabValue) => {
    if (defectFinder?.defect_detector_prompts?.char_limits) {
      if (tabValue === 'Short') {
        return defectFinder?.defect_detector_prompts?.char_limits?.char_limit_default;
      } else if (tabValue === 'Long') {
        return defectFinder?.defect_detector_prompts?.char_limits?.char_limit_longer;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  function generateComment(template = '', category = '', line = '', issue = '', charLimit = '') {
    return template
      .replace("'{{category}}'", category || '')
      .replace("'{{line_item}}'", line || '')
      .replace("'{{user_prompt}}'", issue || '')
      .replace("'{char_limit_default}'", charLimit)
      .replace("'{char_limit_longer}'", charLimit)
      .replace("'{char_limit}'", charLimit);
  }

  const MAX_FILE_SIZE = 20 * 1024 * 1024;
  const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];

  const handleNext = async (status, value) => {
    const currentPromptTemplate = getPromptTemplate(tabValue, includeRecommendation);
    const currentPromptLimit = getCharacterLimit(tabValue);
    const result = generateComment(currentPromptTemplate, categoryName, lineName, additionalInfo, currentPromptLimit);
    try {
      setLoading(true);
      const firstImageFileName = images[0].id;
      if (!status) {
        const updateLoading = Object.fromEntries(images.map(img => {
          const isDrag = typeof img.file?.file === "string";
          const key = isDrag ? img.name : img.file.name;
          return [key, true];
        }));
        const updateData = Object.fromEntries(images.map(img => {
          const isDrag = typeof img.file?.file === "string";
          const key = isDrag ? img.name : img.file.name;
          return [key, null];
        }));
        setDatas(updateData);
        setDefaultSelect(firstImageFileName);
        setDataLoading(updateLoading);
        let successCount = 0;
        await Promise.all(
          images.map(async (img) => {
            const isDrag = typeof img.file?.file === "string";
            const key = isDrag ? img.name : img.file.name;
            const formData = new FormData();
            // Attach either binary file or S3 URL
            if (img.file instanceof File || img.file instanceof Blob) {
              formData.append("file", img.file);
            } else if (typeof img.file?.file === "string") {
              formData.append("s3_image_urls", img.file.file);
            }
            formData.append("prompt", result)
            try {
              const res = await axios.post(
                aiUrl(),
                formData,
                {
                  headers: {
                    Authorization: defectFinder?.ai_token || '',
                    "Content-Type": "multipart/form-data",
                  },
                }
              );
              if (res.status === 200) {
                successCount++;
                // Use consistent key for both conditions
                setDatas((prev) => ({ ...prev, [key]: { ...res.data, checked: false, file: img } }));
                setDataLoading((prev) => ({ ...prev, [key]: false }));

                if (img.id === firstImageFileName) {
                  const update = { ...res.data, checked: false, name: key, file: img };
                  setSelectedContent((prev) => (prev === null ? update : prev));
                }
              }
            } catch (err) {
              setDataLoading((prev) => ({ ...prev, [key]: "error" }));
            }
          })
        );
        handleupdateDefectQuotacount(successCount);
      } else {
        const isDrag = typeof value?.file?.file === "string";
        const key = isDrag ? value.name : value.file.name;
        setDataLoading((prev) => ({ ...prev, [key]: true }));
        const retryForm = new FormData();
        if (value.file instanceof File || value.file instanceof Blob) {
          retryForm.append("file", value.file);
        } else if (typeof value.file?.file === "string") {
          retryForm.append("s3_image_urls", value.file.file);
        }
        retryForm.append("prompt", result);
        try {
          const res = await axios.post(
            aiUrl(),
            retryForm,
            {
              headers: {
                Authorization: defectFinder?.ai_token || '',
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (res.status === 200) {
            setDataLoading((prev) => ({ ...prev, [key]: false }));
            setDatas((prev) => ({ ...prev, [key]: res.data }));
            setSelectedContent({ ...res.data, name: key });
            handleupdateDefectQuotacount(1);
          }
        } catch (err) {
          setDataLoading((prev) => ({ ...prev, [key]: "error" }));
        }
      }
    } catch (error) {
      // console.error("Error during handleNext:", error);
    }
  };
  const handleupdateDefectQuotacount = (successCount) => {
    updateDefectData(dispatch, {
      company_key: sessionStorage.getItem("comKey") || "",
      associate_company: sessionStorage.getItem("asoCom") || "",
      counter: defectFinder?.defect_detector_counter > 0 ? defectFinder?.defect_detector_counter - successCount : 0,
    }
    )
  };

  useEffect(() => {
    const accessFlag = storeData?.inspectionData?.data?.REPORT_WRITER_SETTINGS_ACCESS;
    if (accessFlag !== undefined) setReportWriterSettingsAccess(accessFlag);
    setHasFetchedCompanySettings(true);
  }, [showCommentModal, hasFetchedCompanySettings, storeData?.inspectionData?.data?.REPORT_WRITER_SETTINGS_ACCESS]);


  const fetchDefectDetails = () => {
    getDefectData(dispatch, {
      company_key: sessionStorage.getItem("comKey") || "",
      associate_company: sessionStorage.getItem("asoCom") || ""
    })
  }

  const RenderContent = () => {
    return (

      <div>
        <div className="fill_content">
          <span style={{ fontSize: isMobile ? "10px" : "11px", color: "#979797", fontFamily: "Open Sans", }}>
            JPG, JPEG, PNG | Max size: 20 MB | Max 10 images
          </span>
          <span style={{ fontSize: isMobile ? "10px" : "11px", color: "#979797", fontFamily: "Open Sans" }}>
            {images.length}/10 images selected | {defectFinder?.defect_detector_counter && defectFinder.defect_detector_counter} credits remaining today
          </span>
        </div>
        {/* {images.length > 1 &&
          <div style={{ display: "flex", alignItems: "center", marginTop: "15px", paddingRight: "20px", flexDirection: "reverse" }}>

            <Checkbox onChange={(e) => setCommentChecked(e.target.checked)} sx={{ marginLeft: "-10px" }} />
            <span style={{ color: "#757575", fontWeight: 400 }}>Process Image Individually</span>
          </div>
        } */}

        <Box>
          <Typography fontWeight={500} color={"#333333"} sx={{ fontSize: "16px !important", fontFamily: "Open Sans !important" }}>Comment Generation Options</Typography>
          <CommentSettings
            selectedTone={selectedTone}
            onToneChange={handleSelectedTone}
            includeRecommendation={includeRecommendation}
            onRecommendationChange={setIncludeRecommendation}
            tabValue={tabValue}
            setTabValue={setTabValue}
            lastBtn={false}
          />
          <Typography variant="body2" sx={{ mb: 1, color: "#757575", fontWeight: 400, mt: 1 }}>
            Add context (optional)
            {/* <InfoAddContext /> */}
          </Typography>
          <TextField
            fullWidth
            value={additionalInfo}
            onChange={(e) => setAdditionalInfo(e.target.value)}
            placeholder="Rusted material, broken pieces, etc."
            sx={{
              fontSize: "14px !important",
              '& .MuiOutlinedInput-root': {
                height: '40px',
                fontSize: "14px !important",
                fontWeight: 400,

                backgroundColor: "#FFFFFF",
                color: '#454545',
                '& fieldset': {
                  fontSize: "14px !important",
                  borderColor: '#D5D5D5',
                  borderWidth: '1px',
                },
                '&:hover fieldset': {
                  fontSize: "14px !important",
                  borderColor: '#D5D5D5',
                },
                '&.Mui-focused fieldset': {
                  fontSize: "14px !important",
                  borderColor: '#D5D5D5',
                  borderWidth: '1px',
                },
              },
            }}
          />
          {/* <div style={{ display: "flex", alignItems: "center" }}>
            <Checkbox onChange={(e) => setCheckbox((prev) => ({ ...prev, prompt: e.target.checked }))} sx={{ marginLeft: "-10px" }} />
            <span style={{ color: "#757575", fontWeight: 400 }}> Use custom prompt</span>
          </div> */}
        </Box>
      </div>
    )
  }
  const checkedCount = Object.values(datas).filter(item => item?.checked).length;

  const getButtonLabel = () => {
    if (value === tabIndexes.newComment) return editComment ? "Edit Comment" : "Add New Comment";
    if (value === tabIndexes.commentLibrary) return `Add ${selected?.length} comments`;
    if (value === tabIndexes.aiDefectFinder) {
      if (loading || selectedContent) {
        return `Add ${checkedCount} comments`;
      }
      return "Analyze images";
    }
    return "Add comment"; // Fallback
  };
  function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      if (property !== "expand" && property !== "name") {
        onRequestSort(event, property);
      }
    };

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
          </TableCell>
          {headCells.map((headCell) => (
            <TableCell key={headCell.id} align={headCell.id === "name" ? "center" : "left"} sortDirection={orderBy === headCell.id ? order : false} style={{ width: headCell.width ? headCell.width : "" }} className="cl-table-head">
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                IconComponent={() => (headCell.id !== "name" && headCell.id !== "global" ? <UnfoldMoreIcon className="cl-sort-icon" /> : "")}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const shouldShowCommentLibraryTab = !editComment && hasCommentLibraryData;

  // Calculate tab indexes consistently
  const tabIndexes = useMemo(() => {
    const indexes = {
      commentLibrary: shouldShowCommentLibraryTab ? 0 : -1,
      newComment: shouldShowCommentLibraryTab ? 1 : 0,
      aiDefectFinder: shouldShowCommentLibraryTab ? 2 : 1
    };
    return indexes;
  }, [shouldShowCommentLibraryTab]);

  // Get the current active tab index based on value
  const getActiveTabIndex = (value) => {
    if (shouldShowCommentLibraryTab) {
      return value; // 0, 1, or 2
    } else {
      return value === tabIndexes.aiDefectFinder ? 1 : 0; // Map to available indexes
    }
  };
  const remainingImages = defectFinder?.defect_detector_counter - images.length;

  const handleTabChange = (event, newValue) => {
    setRatingValue([]);
    setLocationValue("");
    setTag([]);
    setAddToTemplate(false);
    setAddToLibrary(false);
    setValue(newValue);
  };

  useEffect(() => {
    if (showCommentModal) {
      if (editComment) {
        setValue(tabIndexes.newComment);
      }
      else if (hasCommentLibraryData) {
        setValue(tabIndexes.commentLibrary);
      } else {
        setValue(tabIndexes.newComment);
      }
    }
  }, [showCommentModal]);

  const replacePlaceholdersWithDropdowns = (htmlString, dropdowns, type, commentId, commentUUId, rowDisabled, isTruncate, maxLength) => {
    let newHtmlString = htmlString;
    if (isTruncate) {
      const textboxRegex = /\[textbox[^\]]*\]/g;
      const textboxMatches = htmlString?.match(textboxRegex) || [];
      if (textboxMatches.length > 0) {
        const plainText = htmlString.replace(textboxRegex, '');
        const plainTextLength = plainText.length;
        if (plainTextLength > maxLength || textboxMatches.length > 3) {
          let result = "";
          let currentPlainTextLength = 0;
          let textboxesIncluded = 0;
          let remainingString = htmlString;
          let lastWasTextbox = false;
          while (remainingString.length > 0 && currentPlainTextLength < maxLength) {
            const nextTextboxIndex = remainingString.indexOf('[textbox');
            if (nextTextboxIndex === -1) {
              const remainingChars = Math.min(maxLength - currentPlainTextLength, remainingString.length);
              result += remainingString.substring(0, remainingChars);
              currentPlainTextLength += remainingChars;
              break;
            }
            if (nextTextboxIndex > 0) {
              const textBefore = remainingString.substring(0, nextTextboxIndex);
              const textBeforeLength = textBefore.length;
              const allowedLength = maxLength - currentPlainTextLength;
              if (textBeforeLength <= allowedLength) {
                result += textBefore;
                currentPlainTextLength += textBeforeLength;
              } else {
                result += textBefore.substring(0, allowedLength);
                currentPlainTextLength += allowedLength;
                break;
              }
            }
            const textboxEndIndex = remainingString.indexOf(']', nextTextboxIndex);
            if (textboxEndIndex !== -1) {
              const fullTextbox = remainingString.substring(nextTextboxIndex, textboxEndIndex + 1);
              if (textboxesIncluded < 2) {
                result += fullTextbox;
                textboxesIncluded++;
              } else if (textboxesIncluded === 2) {
                if ((htmlString.match(textboxRegex) || []).length > 2) {
                  result += fullTextbox + '...';
                  break;
                } else {
                  result += fullTextbox;
                  textboxesIncluded++;
                }
              }
              remainingString = remainingString.substring(textboxEndIndex + 1);
              lastWasTextbox = true;
            } else {
              remainingString = remainingString.substring(nextTextboxIndex);
              break;
            }
          }
          if (currentPlainTextLength >= maxLength && !result.endsWith('...')) result += '...';
          newHtmlString = result;
        } else newHtmlString = htmlString;
      } else {
        newHtmlString = htmlString?.slice(0, maxLength);
        if (newHtmlString.length < htmlString.length) newHtmlString += '...';
        const incompleteDropdownRegex = /\[dropdown [a-f0-9\-]+/g;
        const incompleteDropdownMatch = newHtmlString?.match(incompleteDropdownRegex);
        if (incompleteDropdownMatch && incompleteDropdownMatch.length > 0) {
          newHtmlString = htmlString?.slice(0, maxLength + 55);
          const newDropdownMatch = newHtmlString?.match(incompleteDropdownRegex);
          if (newDropdownMatch && newDropdownMatch.length > 1) {
            const dropdownIndex = newHtmlString?.indexOf(newDropdownMatch[1]);
            if (dropdownIndex !== -1) newHtmlString = newHtmlString?.slice(0, dropdownIndex);
          }
          if (!newHtmlString.endsWith('...')) newHtmlString += '...';
        }
      }
    }
    const regexSpecialSymbol = /Ã|Â|ÃÂ/g;
    if (Array?.isArray(dropdowns) && dropdowns?.length > 0) {
      dropdowns?.forEach((dropdown) => {
        const placeholder = `\\[dropdown ${dropdown.dropdown_uuid}\\]`;
        const regex = new RegExp(placeholder, "g");
        const selectElement = document.createElement("select");
        if (Array?.isArray(dropdown?.dropdowns_values?.values)) {
          let newDropdownValues = dropdown?.dropdowns_values?.values;
          newDropdownValues = newDropdownValues?.filter((obj) => !obj?.toUpperCase()?.includes("XXX"));
          if (!newDropdownValues?.find((value) => value?.includes("-----"))) {
            newDropdownValues?.unshift("-------------");
          }
          newDropdownValues?.forEach((value) => {
            const option = document.createElement("option");
            if (value?.length > 40) option.text = `${value.substring(0, 40)}...`;
            else option.text = value;
            option.value = value;
            option.title = value;
            selectElement.appendChild(option);
            if (dropdown.selected_value === value) {
              option.setAttribute("selected", "selected");
            }
            selectElement.classList.add(`${type}-cl-dropdown`);
            selectElement.setAttribute("id", `${dropdown.dropdown_uuid}`);
            selectElement.setAttribute("comment_id", commentId);
            selectElement.setAttribute("comment_uuid", commentUUId);
            selectElement.setAttribute("dropType", type);
            if (rowDisabled) {
              selectElement.setAttribute("disabled", "true");
            } else {
              selectElement.removeAttribute("disabled");
            }
          });
        } else if (Array?.isArray(dropdown?.dropdowns_values)) {
          let newDropdownValues = dropdown?.dropdowns_values;
          newDropdownValues = newDropdownValues?.filter((obj) => !obj?.toUpperCase()?.includes("XXX"));
          if (!newDropdownValues?.find((value) => value?.includes("-----"))) {
            newDropdownValues?.unshift("-------------");
          }
          newDropdownValues?.forEach((value) => {
            const option = document.createElement("option");
            if (value?.length > 40) option.text = `${value.substring(0, 40)}...`;
            else option.text = value;
            option.value = value;
            option.title = value;
            selectElement.appendChild(option);
            if (dropdown.selected_value === value) {
              option.setAttribute("selected", "selected");
            }
            selectElement.classList.add(`${type}-cl-dropdown`);
            selectElement.setAttribute("id", `${dropdown.dropdown_uuid}`);
            selectElement.setAttribute("comment_id", commentId);
            selectElement.setAttribute("comment_uuid", commentUUId);
            selectElement.setAttribute("dropType", type);
            if (rowDisabled) {
              selectElement.setAttribute("disabled", "true");
            } else {
              selectElement.removeAttribute("disabled");
            }
          });
        }
        newHtmlString = newHtmlString?.replace(regex, selectElement?.outerHTML);
      });
    } else {
      const regexPlainDropdown = /\[dropdown [a-f0-9\-]+\]/g;
      newHtmlString = newHtmlString?.replace(regexPlainDropdown, (match) => {
        const selectId = match.match(/[a-f0-9\-]+/)?.[0] || '';
        return `<select id="${selectId}" class="${type}-cl-dropdown"><option>--------------</option></select>`;
      });
    }
    const replaceInputs = (input_text) => {
      let container = document.createElement("div");
      container.innerHTML = input_text;
      container.innerHTML = container.innerHTML.replace(/\[textbox(.*?)\]/g, (match, attributes) => {
        let idMatch = attributes.match(/id:([^;]+);?/);
        let valueMatch = attributes.match(/value:([^;]+);?/);
        let id = idMatch && idMatch[1].length > 30 ? idMatch[1].trim() : uuid();
        let value = valueMatch ? valueMatch[1].trim() : "";
        const safeValue = value.replace(/\\/g, "\\\\").replace(/"/g, '&quot;');
        return `<input id="${id}" value="${safeValue}" title="${safeValue}" readOnly class="${type}-cl-input" comment_uuid=${commentUUId} style="width: 104px;
                background-color: #f1f9fe;
                height: 24px;
                overflow-wrap: break-word;
                padding: 1px 17px 3px 6px;
                border-radius: 4px;
                border: 1px solid #0F75BC;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                font-size: 14px;
                color: #3B3B3B;
                font-style: normal;
                font-weight: 600;
                max-width: 200px;
                min-width: 104px;
                text-overflow: ellipsis;
                white-space: nowrap;"
                onblur="handleChangeInput(id, value)"
                />`;
      });
      return container.innerHTML;
    }
    newHtmlString = replaceInputs(newHtmlString);
    if (isTruncate) {
      const parser = new DOMParser();
      const parsedDocument = parser.parseFromString(newHtmlString, "text/html");
      const correctedHtml = parsedDocument.body.innerHTML;
      return parse(correctedHtml?.replace(regexSpecialSymbol, ""));
    }
    return parse(newHtmlString?.replace(regexSpecialSymbol, "")) || "";
  };

  const tableContainerRef = useRef(null);

  useEffect(() => {
    const tableContainer = document.querySelector('.custom-table-container');
    if (tableContainer) {
      tableContainer.scrollTop = 0;
    }
  }, [page, apiPageCount]);

  const isSelected = (id) => selected.indexOf(id) !== -1;
  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
    const handlePageChange = (event, newPage) => {
      onPageChange(event, newPage);
      const tableContainer = document.querySelector('.custom-table-container');
      if (tableContainer) {
        tableContainer.scrollTop = 0;
      }
    };
    const handleFirstPageButtonClick = (event) => {
      handlePageChange(event, 0);
    };
    const handleBackButtonClick = (event) => {
      handlePageChange(event, page - 1);
    };
    const handleNextButtonClick = (event) => {
      handlePageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event) => {
      handlePageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
          {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setApiPageCount(newPage);
  };

  const isRowExpanded = (rowId) => expandedRows.includes(rowId);

  const handleClickChangeDropdown = (event, id, row, action) => {
    !isRowExpanded(id) && toggleRowExpansion(row.id);
    const selectedIndex = selected.indexOf(row.uuid);
    if (action === "dropdown") {
      if (!isSelected(row.uuid)) {
        let newSelected = [];
        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, row.uuid);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
        setSelected(newSelected);
      }
    }
  };

  const handleChangeDropdown = (event, dropdownUuid, commentId, type, commentUUId, commentDisabled) => {
    if (event && typeof event.stopPropagation === "function") {
      event.stopPropagation();
    }
    commentDisabled === "false" && handleClickChangeDropdown(event, commentId, { id: commentId, uuid: commentUUId }, "dropdown");
    const selectedValue = event.target.value;
    const dropdownValuesArrays = commentListData.map((item) => {
      const commentDropdowns = item.comment_dropdowns || [];
      const summaryDropdowns = item.summary_comment_dropdowns || [];
      const allDropdowns = [...commentDropdowns, ...summaryDropdowns];
      return allDropdowns?.filter((dropdown) => dropdown?.dropdown_uuid === dropdownUuid)?.map((dropdown) => dropdown?.dropdowns_values?.values);
    });
    const dropdownValues = dropdownValuesArrays.flat().find((values) => values.length > 0);
    let payload = {
      comment_id: commentId,
      dropdown_uuid: dropdownUuid,
      dropdown_type: type === "comment" ? "1" : "2",
      selected_value: selectedValue,
      dropdowns_values: dropdownValues,
    };
    updateDropDownValues(dispatch, payload);
    let commentIndex = commentListData?.findIndex((item) => item.uuid === commentUUId);
    if (commentIndex !== -1) {
      if (type === "comment") {
        commentListData[commentIndex].comment_dropdowns?.forEach((dropdown) => {
          if (dropdown?.dropdown_uuid === dropdownUuid) {
            dropdown.selected_value = selectedValue;
          }
        });
      } else {
        commentListData[commentIndex].summary_comment_dropdowns?.forEach((dropdown) => {
          if (dropdown?.dropdown_uuid === dropdownUuid) {
            dropdown.selected_value = selectedValue;
          }
        });
      }
      setCommentListData([...commentListData]);
    }
  };

  setTimeout(() => {
    let commentDropElements = document.querySelectorAll(".comment-cl-dropdown");
    commentDropElements?.forEach((element) => {
      const commentId = element.getAttribute("comment_id");
      const dropType = element.getAttribute("dropType");
      const commentUUId = element.getAttribute("comment_uuid");
      const commentDisabled = element.hasAttribute("disabled");
      if (element && !commentDisabled) {
        const stopPropagation = (event) => {
          if (event && typeof event.stopPropagation === "function") {
            event.stopPropagation();
          }
        };
        element.onclick = stopPropagation;
        element.onmousedown = stopPropagation;
        element.onfocus = stopPropagation;
        element.onchange = (event) => {
          handleChangeDropdown(event, element.id, commentId, dropType, commentUUId, commentDisabled);
        };
      }
    });
  }, 100);

  setTimeout(() => {
    let summaryDropElements = document.querySelectorAll(".summary-cl-dropdown");
    summaryDropElements?.forEach((element) => {
      const commentId = element.getAttribute("comment_id");
      const dropType = element.getAttribute("dropType");
      const commentUUId = element.getAttribute("comment_uuid");
      const commentDisabled = element.hasAttribute("disabled");
      if (element && !commentDisabled) {
        const stopPropagation = (event) => {
          if (event && typeof event.stopPropagation === "function") {
            event.stopPropagation();
          }
        };
        element.onclick = stopPropagation;
        element.onmousedown = stopPropagation;
        element.onfocus = stopPropagation;
        element.onchange = (event) => handleChangeDropdown(event, element.id, commentId, dropType, commentUUId, commentDisabled);
      }
    });
  }, 100);

  const handleClearCategories = () => {
    dispatch(clearDefaultCategories())
  }

  const handleSearchFilter = (value) => {
    setPage(0);
    setApiPageCount(0);
    setSearchData(value)
  };
  function getPathFromUrl(url) {
    // Create a URL object
    const urlObj = new URL(url);
    // Remove the leading slash
    return urlObj.pathname.slice(1);
  }
  function getFileNameFromUrl(url) {
    // Split the URL by "/" and get the last part
    const parts = url.split('/');
    return parts[parts.length - 1];
  }


  const handleUpload = async (defectImages, data) => {

    try {
      let baseUrl = await origin();
      let sessionAPIKey = sessionStorage.getItem("CK");
      let sessionSecretKey = sessionStorage.getItem("SK");
      let formData = new FormData();
      const commentUuid = data;

      formData.append("image", defectImages.file.file);
      formData.append("video_thumbnail", defectImages.file.file);
      // Attach metadata with the correct UUID
      formData.append("img_object", JSON.stringify({
        "id": commentUuid,
        "url": null,
        "name": defectImages.file.name,
        "size": defectImages.file.size,
        "type": defectImages.file.type,
        "edited": false,
        "newUrl": null,
        "online": "online",
        "filetype": "image",
        "localUrl": null,
        "OriginUrl": null,
        "created_at": new Date().toISOString().replace('T', ' ').substring(0, 19),
        "editCount": 0,
        "onlineUrl": null,
        "orginName": null,
        "thumbnail": null,
        "is_deleted": 0,
        "order": 1,
        "uploaded_by": parseInt(sessionStorage.getItem("UID")) || 5661,
        "updated_at": new Date().toISOString().replace('T', ' ').substring(0, 19),
        "description": null,
        "OriginlocalUrl": null,
        "isOriginUploaded": true
      }));

      formData.append("inspection_guid", sessionStorage.getItem('guid') || "");
      formData.append("guid", sessionStorage.getItem("guid"));
      formData.append("template_id", templateId);
      formData.append("category_id", categoryUuid);
      formData.append("line_id", lineUuid);
      formData.append("uploaded_by", parseInt(sessionStorage.getItem("UID")));
      formData.append("img_type", "comment");
      formData.append("comment_id", commentUuid); // Use the same UUID here

      // Upload
      const response = await axios.post(
        `${baseUrl}upload_media_for_inspection_template`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
            "api-key": Base64.decode(sessionAPIKey),
            platform: "web",
            "api-platform": "WRW",
            user_id: sessionStorage.getItem("UID"),
            product: sessionStorage.getItem("asoCom"),
            mode: "online",
          },
        }
      );

      return response.data;

    } catch (error) {
      throw error;
    }
  };

  const handleAnalyseDefect = async () => {
    setDisable(true);
    const checkedItems = Object.keys(datas).filter(
      (key) => datas[key]?.checked
    );
    const commentUuids = checkedItems.map(() => uuidv4());
    for (let i = 0; i < checkedItems.length; i++) {
      const key = checkedItems[i];
      const aiResponse = datas[key]?.ai_response;
      const defectImages = datas[key];
      const commentUuid = commentUuids[i];
      const title = formatAIResponseToHTMLTitle(aiResponse);
      const newComment = formatAIResponseToHTML(aiResponse);
      const newEditorContent = formatAIResponseToHTML(aiResponse);
      const isDrag = typeof defectImages?.file?.file?.file === "string";
      const newCreatedComment = await createNewComment(inspectionData, newComment, title, commentUuid, key, isDrag);
      if (!isDrag && newCreatedComment) {
        await handleUpload(defectImages, newCreatedComment);
      }
    }
    let sessionAssociateCompanyKey = Base64.decode(sessionStorage.getItem('AC'));
    let guid = sessionStorage.getItem('guid')
    let sessionUserId = Base64.decode(sessionStorage.getItem('UI'));
    dispatch(getInspectionDataWithOutLoader({ guid: guid, associate_company: sessionAssociateCompanyKey, user_id: sessionUserId }))
    handleClose();
  };

  const handleAddSelectedComment = () => {
    let payload = {
      comment_uuid: selected,
      inspection_id: storeData?.inspectionData?.data?.inspection_id,
      template_id: templateId,
      category_uuid: categoryUuid,
      line_uuid: lineUuid,
      inspection_guid: storeData.inspectionData?.data?.guid,
    };
    // The selected comments came out of the narrative library, so they have to be
    // added through add-comment-to-report rather than the non-narrative endpoint.
    if (isTexasNarrativeCL) addSelectedCommentesFromCl(dispatch, payload);
    else addSelectedCommentesFromClNN(dispatch, payload);
    handleClose();
  };

  const replaceSelectWithDropdown = (content, className) => {
    let tempDiv = document.createElement("div");
    tempDiv.innerHTML = content;
    tempDiv.querySelectorAll("span[id^='dropdown_'], span[id^='[dropdown ']").forEach((span) => {
      const spanIdMatch = span.id.match(/^\[dropdown (.*?)\]$/) || span.id.match(/^dropdown_(.*)$/);
      if (spanIdMatch) {
        const spanId = spanIdMatch[1];
        let outerSpan = span;
        while (
          outerSpan.parentElement &&
          outerSpan.parentElement.tagName.toLowerCase() === "span" &&
          outerSpan.parentElement.getAttribute("contenteditable") === "false"
        ) {
          outerSpan = outerSpan.parentElement;
        }
        outerSpan.replaceWith(`[dropdown ${spanId}]`);
      }
    });
    tempDiv.querySelectorAll(`select.${className}`).forEach((select) => {
      const selectId = select.id;
      select.replaceWith(`[dropdown ${selectId}]`);
    });
    var inputs = tempDiv.querySelectorAll("input");
    inputs.forEach((input) => {
      const escapeHTML = (str) => str.replace(/"/g, "&quot;");
      let id = input.id ? `id:${input.id}; ` : "";
      let value = input.value ? `value:${escapeHTML(input.value)}; ` : "";
      let placeholder = `[textbox ${id}${value}]`.trim();
      const wrapper = input.closest(".froala-dynamic-input-wrapper");
      if (wrapper) {
        wrapper.outerHTML = placeholder;
      } else {
        input.outerHTML = placeholder;
      }
    });
    return serializeNbspEntities(collapseFormattingWhitespace(tempDiv.innerHTML))
      .replace(/<div>[ \t\n\r\f\v]*<\/div>/g, "")
      .trim();
  };

  const addToTemplateApiCall = async (templateGuid, categoryUuid, lineUuid, comment, categoryParentUuid, lineParentUuid) => {
    let baseUrl = await origin();
    let sessionAPIKey = sessionStorage.getItem("CK");
    let sessionSecretKey = sessionStorage.getItem("SK");
    let addToTemplateApiPayload = {
      template_guid: templateGuid,
      categoryUuid: categoryUuid,
      lineUuid: lineUuid,
      comment: comment,
      categoryParentUuid: categoryParentUuid,
      lineParentUuid: lineParentUuid
    }
    await axios.post(`${baseUrl}master-template/add-comment`, addToTemplateApiPayload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
        "api-key": `${Base64.decode(sessionAPIKey)}`,
        platform: "web",
        "api-platform": "WRW",
      },
    });
    setAddToTemplate(false);
  }

  const createNewComment = async (inspectionData, newCommentAdded, title = null, predefinedUuid = null, imageKey = null, isDrag = null) => {
    setDisableCommentBtn(true);
    const finalTitle = stripLeadingPunctuationFromPlainText(title || commentTitle);
    const commentHtmlForSave = normalizeDropdownPlaceholderSyntax(
      stripLeadingPunctuationFromHtml(newCommentAdded ?? "")
    );
    const commentUuids = predefinedUuid;
    let templateIndex = inspectionData?.inspectiontemplates?.findIndex((itm) => itm.template_id === templateId);
    let categoryIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.id === categoryId);
    let lineIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines?.findIndex((line) => line.uuid === lineUuid);
    let prevData = JSON.parse(JSON.stringify(inspectionData));
    delete prevData?.report_media_library_files;
    let templateData = inspectionData?.inspectiontemplates[templateIndex]?.location_data;
    let colOne = templateData?.filter(loc => loc.col === '1')
    let colTwo = templateData?.filter(loc => loc.col === '2')
    let colThree = templateData?.filter(loc => loc.col === '3')
    const allCols = [...(colOne || []), ...(colTwo || []), ...(colThree || [])];
    let commentIndex = inspectionData?.inspectiontemplates[templateIndex]?.categories[categoryIndex]?.lines[lineIndex]?.comments?.findIndex((itm) => itm.uuid == commentUuid);
    let response;
    let newComment;
    const inputControls = isDrag ? [
      {
        type: "Media",
        data: images.filter((item) => item.name === imageKey).map((item) => {
          const url = item.file?.file || item.preview || '';
          return {
            ...item,
            name: getFileNameFromUrl(url),
            OriginUrl: getPathFromUrl(url),
            onlineUrl: getPathFromUrl(url),
            thumbnail: getPathFromUrl(url),
            thumbnail_url: getPathFromUrl(url),
            OriginThumbnail: getPathFromUrl(url)
          };
        }),
        prompt: "Media",
        updated_at: new Date().toISOString().replace("T", " ").substring(0, 19),
        uuid: uuidv4()
      }
    ] : [];
    const matchedIds = typeof locationValue === "string" ? locationValue : [
      ...allCols?.filter((item) => locationValue.includes(item.value))?.map((item) => item.value),
      ...locationValue?.filter((val) => !allCols?.some((item) => item.value === val))].filter(Boolean).join(",");
    const defaultLocation = templateData?.filter(
      (item) => locationValue.includes(item.value) && item?.uuid && item?.value
    )?.map((item) => ({ id: item.uuid, name: item.value, }));
    if (!editComment) {
      const firstRatingId = Array.isArray(ratingValue) && ratingValue.length > 0 && ratingValue[0].Id
        ? ratingValue[0].Id
        : null;
      newComment = {
        template_id: templateId,
        category_id: categoryId,
        category_uuid: categoryUuid,
        line_uuid: lineUuid,
        title: finalTitle,
        comment: replaceSelectWithDropdown(commentHtmlForSave, 'comment'),
        comment_dropdowns: editorContent?.dropdownList || [],
        add_to_library: addToLibrary,
        location: matchedIds || "",
        default_location: defaultLocation,
        defaultRating_id: firstRatingId,
        // Remember when the template default was taken off this comment so it stays off.
        removed_default_rating_id: resolveRemovedDefaultRatingId(ratingValue, templateRatingData),
        tag_ids: tag.map((item) => item.id),
        ratings: ratingValue,
        comment_input_controls: inputControls,
        inspection_guid: storeData.inspectionData?.data?.guid,
      };
      let baseUrl = await origin();
      let sessionAPIKey = sessionStorage.getItem("CK");
      let sessionSecretKey = sessionStorage.getItem("SK");
      response = await axios.post(`${baseUrl}comments`, newComment, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
          "api-key": `${Base64.decode(sessionAPIKey)}`,
          platform: "web",
          "api-platform": "WRW",
        },
      });
      if (response.data.comment.comment_input_controls?.length > 0 && response.data.comment.comment_input_controls.find((item) => item.type === "Location")?.data) response.data.comment.comment_input_controls.find((item) => item.type === "Location").data = matchedIds || "";
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments?.unshift(response?.data?.comment);
      dispatch(updateCommentData(prevData));
      if (addToTemplate) {
        addToTemplateApiCall(
          prevData.inspectiontemplates[templateIndex]?.master_template_guid,
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex]?.uuid,
          commentIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]?.uuid,
          response?.data?.comment,
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex]?.parent_uuid,
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]?.parent_uuid
        )
      }
    }
    else {
      let locationObject = {
        comment_input_control_id: null,
        uuid: uuidv4(),
        prompt: "Location",
        values: [],
        type: "Location",
        data: matchedIds || "",
        updated_at: await GetUTCTime(),
        created_at: await GetUTCTime(),
      };
      let ratingObject = {
        comment_input_control_id: null,
        uuid: uuidv4(),
        prompt: "Rating",
        values: [],
        type: "Rating",
        data: ratingValue,
        updated_at: await GetUTCTime(),
        created_at: await GetUTCTime(),
      };
      let ratingIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex]?.comment_input_controls?.findIndex((itm) => itm.type === "Rating");
      let locationIndex = prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex]?.comment_input_controls?.findIndex((itm) => itm.type === "Location");
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].prompt = finalTitle;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].recommendation = replaceSelectWithDropdown(commentHtmlForSave, 'comment');      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_dropdowns = editorContent?.dropdownList;
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].tags = tag;
      // Remember when the template default was taken off this comment so it stays off.
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].removed_default_rating_id = resolveRemovedDefaultRatingId(ratingValue, templateRatingData);
      if (prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls) {
        if (ratingIndex !== -1) {
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls[ratingIndex].data = ratingValue;
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls[ratingIndex].updated_at = await GetUTCTime();
        } else prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls.push(ratingObject);
        if (locationIndex !== -1) {
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls[locationIndex].data = matchedIds || "";
          prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls[locationIndex].updated_at = await GetUTCTime();
        } else prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].comment_input_controls.push(locationObject);
      }
      prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].updated_at = await GetUTCTime();
      if (prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].is_mannual_prompt !== undefined) {
        prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex].comments[commentIndex].is_mannual_prompt = 1;
      }
      let filteredObject = cleanPayloadOnCommentLevel(prevData, templateIndex, categoryIndex, lineIndex, commentIndex, 'editComment');
      UpdateTemplateDataSpecific(dispatch, prevData, filteredObject);
    }
    setLineData(prevData.inspectiontemplates[templateIndex].categories[categoryIndex].lines[lineIndex]);
    setLocationValue([]);
    setTag([]);
    setRatingValue([]);
    setCommentTitle("");
    setEditorContent({ innerHTML: "", dropdownList: [] })
    setShowCommentModal(false);
    return !editComment ? response?.data?.comment?.uuid : commentUuids;
  };

  function toggleAllRowsExpansion() {
    const allRowIds = commentListData?.map((row) => row.id);
    setExpandedRows((prevExpandedRows) => (prevExpandedRows.length === allRowIds.length ? [] : allRowIds));
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const selectedComment = commentListData?.map((n) => n.id);
      setSelected(selectedComment);
      return;
    }
    setSelected([]);
  };

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: <LastPageIcon className="cl-table-exp-icon" onClick={toggleAllRowsExpansion} />,
      width: 100
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
      width: 100
    },
    {
      id: "comment",
      numeric: false,
      disablePadding: false,
      label: "Comment Description",
      width: 100
    },
    ...(showRatingColumn ? [{
      id: "rating",
      numeric: false,
      disablePadding: false,
      label: "Rating",
      width: 100
    }] : []),
    {
      id: "updated_at",
      numeric: false,
      disablePadding: false,
      label: "Last Modified",
      width: 100
    },
  ];

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setApiPageCount(0);
  };

  // Pulls the same narrative library the narrative modal reads, then reshapes each row
  // into the non-narrative shape this table renders: `comment` rather than
  // `comment_text`, ratings flattened, summary fields dropped entirely.
  const getNarrativeCLData = async (newPage = null, selectedTagList = null) => {
    const tags = selectedTagList || selectedFilterTagID || [];
    try {
      const baseUrl = await origin();
      const sessionAPIKey = sessionStorage.getItem("CK");
      const sessionSecretKey = sessionStorage.getItem("SK");
      const response = await axios.get(`${baseUrl}get-comment-library-list`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
          "api-key": `${Base64.decode(sessionAPIKey)}`,
          platform: "web",
          user_id: sessionStorage.getItem("UID"),
          product: sessionStorage.getItem("asoCom"),
          mode: "online",
        },
        params: {
          page: newPage ? newPage : apiPageCount + 1,
          page_count: rowsPerPage,
          search: searchData?.trim() || "",
          sort_field: parameters.orderBy || undefined,
          sort_direction: parameters.order || "asc",
          ...(tags.length > 0 ? { tags } : {}),
        },
      });
      const data = response?.data?.data?.data || [];
      setInitialTableData(data.map(toNonNarrativeRow));
      setCommentListData(data.map(toNonNarrativeRow));
      setNarrativeTotalCount(response?.data?.data?.total || 0);
      if (!hasCommentLibraryData) setHasCommentLibraryData(data.length > 0);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  const getCLData = (newPage = null, selectedTagList = null) => {
    const delayDebounce = setTimeout(async () => {
      if (isTexasNarrativeCL) {
        await getNarrativeCLData(newPage, selectedTagList);
        return;
      }
      let params = `page=${newPage ? newPage : apiPageCount + 1}&rows_per_page=${rowsPerPage}&search=${searchData || ""}&sort_direction=${parameters.order || ""}&sort_field=${parameters.orderBy || ""}`;
      if (selectedTagList) {
        const filterParams = selectedTagList.map((id, index) => `filter_tags[${index}]=${id}`).join("&");
        params += `&${filterParams}`;
      } else if (selectedFilterTagID?.length > 0) {
        const filterParams = selectedFilterTagID.map((id, index) => `filter_tags[${index}]=${id}`).join("&");
        params += `&${filterParams}`;
      }
      await getCommentLibraryListNonNarrative(dispatch, params);
    }, 10);
    return () => clearTimeout(delayDebounce);
  };

  const visibleRows = useMemo(() => {
    const dataToSort = commentListData?.length > 0 ? commentListData : [];
    return dataToSort;
  }, [commentListData, order, orderBy,]);
  // function extractParagraphContent(html) {
  //   const parser = new DOMParser();
  //   const doc = parser.parseFromString(html || "", "text/html");

  //   doc.querySelectorAll("div").forEach(div => div.remove());

  //   const remainingText = (doc.body.textContent || "").trim();

  //   return `<p>${remainingText}</p>`;
  // }


  // const ParagraphContent = extractParagraphContent(recommendation)

  useEffect(() => {
    if (storeData.inspectionData) {
      setInspectionData(storeData.inspectionData?.data);
    }
  }, [storeData.inspectionData]);

  const commentFormInitKeyRef = useRef(null);

  useEffect(() => {
    if (!showCommentModal) {
      commentFormInitKeyRef.current = null;
      return;
    }

    const initKey = [
      editComment,
      commentUuid ?? "",
      prompt ?? "",
      recommendation ?? "",
      is_mannual_prompt ?? "",
      JSON.stringify(comment_dropdowns ?? null),
      JSON.stringify(tags ?? null),
      JSON.stringify(comment_input_controls ?? null),
    ].join("|");
    if (commentFormInitKeyRef.current === initKey) {
      return;
    }
    commentFormInitKeyRef.current = initKey;

    if (editComment) {
      if (is_mannual_prompt !== undefined) {
        setCommentTitle(is_mannual_prompt === 0 ? "" : (prompt || ""));
      } else {
        setCommentTitle(prompt || "");
      }
      setEditorContent({ innerHTML: recommendation || "", dropdownList: comment_dropdowns || [] });
    } else {
      setCommentTitle("");
      setEditorContent({ innerHTML: "", dropdownList: [] });
    }
    setTag(tags || []);
    setRatingValue(resolveModalRatings());
    setLocationValue(comment_input_controls?.find((el) => el.type === "Location")?.data || "");
  }, [
    showCommentModal,
    editComment,
    commentUuid,
    prompt,
    recommendation,
    comment_dropdowns,
    tags,
    comment_input_controls,
    is_mannual_prompt,
  ]);

  useEffect(() => {
    const templateData = inspectionData?.inspectiontemplates?.find((template) => template.template_id === templateId);
    if (templateData?.master_template_guid && showCommentModal) dispatch(getDefaultCategories(`?category_uuid=${categoryUuid === parentUuid ? categoryUuid : parentUuid}&template_guid=${templateData?.master_template_guid}&is_narrative_template=${isNarrative ? 1 : 0}&category_name=${categoryName || ""}`));
    if (!editComment) {
      setLoader(true)
      if (showCommentModal) {
        // The rows come from the narrative library, so the filter must offer its tags.
        if (isTexasNarrativeCL) getCommentLibraryTagList(dispatch);
        else getCLTagsListNonNarrative(dispatch);
      }
    }
  }, [showCommentModal, categoryId, inspectionData?.inspectiontemplates]);

  useEffect(() => {
    if (!showCommentModal) return;
    let isMounted = true;

    const prefetchNewCommentTags = async () => {
      try {
        const baseUrl = await origin();
        const sessionAPIKey = sessionStorage.getItem("CK");
        const sessionSecretKey = sessionStorage.getItem("SK");
        const res = await axios.get(`${baseUrl}tags`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
            "api-key": `${Base64.decode(sessionAPIKey)}`,
            platform: "web",
            "api-platform": "WRW",
          },
        });

        if (isMounted) {
          setPrefetchedNewCommentTags(res?.data?.data || []);
        }
      } catch (error) {
        if (isMounted) {
          setPrefetchedNewCommentTags([]);
        }
      }
    };

    prefetchNewCommentTags();
    return () => {
      isMounted = false;
    };
  }, [showCommentModal]);

  useEffect(() => {
    if (!editComment) { if (showCommentModal) getCLData() }
  }, [showCommentModal, rowsPerPage, apiPageCount, order, searchData, selectedFilterTagID]);

  useEffect(() => {
    // The narrative path sets the rows itself; the non-narrative slice may still hold
    // a previous line's response and would otherwise clobber them.
    if (isTexasNarrativeCL) return;
    if (!editComment) {
      if (showCommentModal && storeData?.commentLibraryListDataNnt?.data) {
        setInitialTableData(storeData.commentLibraryListDataNnt.data);
        setCommentListData(storeData.commentLibraryListDataNnt.data);
        if (!hasCommentLibraryData) {
          setHasCommentLibraryData(Array.isArray(storeData.commentLibraryListDataNnt.data) && storeData.commentLibraryListDataNnt.data.length > 0);
        }
        setLoader(false);
      }
    }
  }, [storeData.commentLibraryListDataNnt, showCommentModal]);

  const tabLabels = {
    [tabIndexes.commentLibrary]: "Comment Library",
    [tabIndexes.newComment]: editComment ? "Edit comment" : "New comment",
    [tabIndexes.aiDefectFinder]: "AI Defect Detector"
  };

  const currentTabLabel = tabLabels[getActiveTabIndex(value)];

  return (
    <Dialog className="dialog-content-comment-library-nn" open={showCommentModal} onClose={handleClose} aria-labelledby="category-modal" aria-describedby="category-modal-description">
      <DialogTitle pb={0}>
        <Grid container display={"flex"}>
          <Grid item xs={11} display={"flex"} justifyContent={"flex-start"}>
            <Typography className="non-narrative-comment-title">{`${categoryName ? categoryName + " -" : ""} ${editComment ? "Edit comment" : "Add comment"}`}</Typography>
          </Grid>
          <Grid item xs={1} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
            <div className="close-wrapper-new-category-right" style={{ marginTop: "10px" }}>
              <CloseIcon onClick={handleClose} />
            </div>
          </Grid>
        </Grid>
        {!editComment && loader ? (
          <Box className="loader-container-comment-library" sx={{ width: "100%" }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Tabs
              value={getActiveTabIndex(value)}
              className="lineDetails__tab cl_tabs"
              onChange={handleTabChange}
              aria-label="line_details_tab"
              sx={{ paddingTop: "0px" }}
            >
              {shouldShowCommentLibraryTab && !editComment && (
                <Tab
                  label="Comment Library"
                  className={`tab__label cl_tab_panel ${getActiveTabIndex(value) === tabIndexes.commentLibrary ? "active" : "inactive"}`}
                  {...a11yProps(tabIndexes.commentLibrary)}
                />
              )}

              <Tab
                label={editComment ? "Edit comment" : "New comment"}
                className={`tab__label cl_tab_panel captitalize ${getActiveTabIndex(value) === tabIndexes.newComment ? "active" : "inactive"}`}
                {...a11yProps(tabIndexes.newComment)}
              />
              {!editComment && (
                <Tab
                  className={`cl_tab_panel_image-defect-finder captitalize ${getActiveTabIndex(value) === tabIndexes.aiDefectFinder ? "active" : "inactive"}`}
                  label={"AI Defect Detector"}
                  {...a11yProps(tabIndexes.aiDefectFinder)}
                />
              )}
              {!editComment &&
                <Typography variant="contained" size="small" className="ai-text">
                  <MaskSparkle />
                </Typography>
              }
            </Tabs>
            <Divider />
          </>
        )}
      </DialogTitle>
      <DialogContent>
        {!editComment && loader ? (
          <Box className="loader-container-comment-library" sx={{ width: "100%" }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container>
            <Grid item xs={12}>
              <Box className={currentTabLabel === "AI Defect Detector" ? "" : "dialog-content-comment-library"}>
                {shouldShowCommentLibraryTab && (
                  <TabPanel value={getActiveTabIndex(value)} index={tabIndexes.commentLibrary} className="tab_panel_cLibrary">
                    <Box sx={{ width: "100%" }}>
                      <Grid container className="cl-search-container">
                        <Grid item xs={12} md={3} className="cl-search-bar">
                          <div className="cl-search">
                            <CommentSearch onSearch={(val) => handleSearchFilter(val)} value={searchData} />
                            <SearchIcon className="cl-search-icon" />
                          </div>
                        </Grid>
                        <Grid item xs={12} md={5} mb={1}>
                          <FilterTags setLoader={setLoader} setPage={setPage} categoryId={categoryId} templateGuid={inspectionData?.inspectiontemplates[0]?.master_template_guid} dispatch={dispatch} getCommentLibraryList={getCommentLibraryList} searchData={searchData} filterTagList={isTexasNarrativeCL ? storeData?.clTag : storeData?.clTagNN} setCommentListData={setCommentListData} commentListData={commentListData} selectedFilterTagID={selectedFilterTagID} setSelectedFilterTagID={setSelectedFilterTagID} search={search} initialTableData={initialTableData} defaultCategories={storeData.defaultCategories} handleClearCategories={handleClearCategories} isNarrative={isNarrative} getClListForSearch={getCLData} />
                        </Grid>
                        <Grid item xs={12} md={1.5}></Grid>
                      </Grid>
                      <TableContainer ref={tableContainerRef} className="custom-table-container cl-table-container">
                        <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"medium"}>
                          <EnhancedTableHead
                            numSelected={selected?.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={commentListData?.length}
                          />
                          <TableBody>
                            {visibleRows?.map((row, index) => {
                              const isItemSelected = isSelected(row.uuid);
                              const labelId = `enhanced-table-checkbox-${index}`;
                              let rowDisabled = existingCommentUuids?.includes(row.uuid) ? true : false;;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}
                                  key={row.id}
                                  selected={isItemSelected}
                                  sx={{ cursor: "pointer" }}
                                  className={`cl_row ${rowDisabled ? "disabled cl-row-disabled" : ""}`}
                                >
                                  <TableCell
                                    padding="checkbox"
                                    onClick={(event) => (rowDisabled ? undefined : handleClick(event, row.id, row))}
                                    className={`cl-checkbox-col ${rowDisabled ? (isItemSelected ? "cl-check-active" : "") : isRowExpanded(row.id) ? (isItemSelected ? "cl-check-active" : "") : ""}`}
                                  >
                                    <Checkbox
                                      sx={{
                                        height: "37.5px !important",
                                        "& .MuiSvgIcon-root": { fontSize: "20px !important" },
                                      }}
                                      color="primary"
                                      checked={isItemSelected || rowDisabled}
                                      disabled={rowDisabled}
                                    />
                                  </TableCell>
                                  <TableCell
                                    id={labelId}
                                    scope="row"
                                    padding="none"
                                    className={`cl-row-status cl-exp-col ${rowDisabled ? "row_disabled" : ""}`}
                                    sx={{ textAlign: "center" }}
                                  >
                                    <IconButton
                                      sx={{ height: "19.5px", width: "19.5px", "& .MuiSvgIcon-root": { fontSize: "19.5px !important" } }}
                                      onClick={() => (rowDisabled ? undefined : toggleRowExpansion(row.id))}
                                    >
                                      {rowDisabled ? <ExpandLessIcon className="disabled_collapse_cl_icon" /> : isRowExpanded(row.id) ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                    </IconButton>
                                  </TableCell>
                                  <TableCell
                                    className={`cl-title-col ${rowDisabled ? "row_disabled" : ""}`}
                                    align="left"
                                    sx={{
                                      overflow: "hidden",
                                      whiteSpace: " !important",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <TruncatedTexts
                                      text={row.title}
                                      expanded={isRowExpanded(row.id)}
                                      fieldType="title"
                                      rowId={row.id}
                                      rowDisabled={rowDisabled}
                                    />
                                  </TableCell>
                                  <TableCell className={`cl-comment-col ${rowDisabled ? "row_disabled" : ""}`} align="left" sx={{ width: "300px", minWidth: "300px", maxWidth: "300px", overflow: "hidden" }}>
                                    <TruncatedText
                                      text={row.comment !== null && row.comment !== undefined ? row.comment?.replace(/<\/?[^>]+(>|$)/g, "") : ""}
                                      expanded={isRowExpanded(row.id)}
                                      fieldType={"comment_text"}
                                      commentDropdowns={row?.comment_dropdowns}
                                      textType={"comment"}
                                      rowId={row?.id}
                                      rowUuid={row?.uuid}
                                      rowDisabled={rowDisabled}
                                    />
                                    <CommentTags tags={row?.tags} />
                                  </TableCell>
                                  {showRatingColumn ? (
                                    <TableCell className={`cl-summary-col ${rowDisabled ? "row_disabled" : ""}`} align="left" >
                                      {row?.ratings?.length !== 0
                                        ? row?.ratings?.map((element) => (
                                          <div className="cl_rating_square_container">
                                            <div
                                              className="rating_square"
                                              style={{
                                                background: `${element?.Color}`,
                                                padding: "4px",
                                              }}
                                            ></div>
                                            <div className="cl_rating_name_text">{element?.Name}</div>
                                          </div>
                                        ))
                                        : ""}
                                    </TableCell>
                                  ) : null}
                                  <TableCell className={`cl-global-col ${rowDisabled ? "row_disabled" : ""}`} sx={{ minWidth: "160px" }} >
                                    <div className="time-formart">
                                      <span className="date-placeholder-comment" style={{ marginLeft: "12px" }}>{moment(row?.updated_at)?.format("MM/DD/YYYY")}</span>
                                      <span className="time-placeholder" style={{ marginLeft: "12px" }}>{moment(row?.updated_at)?.format("LT")}</span>
                                    </div>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                            {visibleRows.length === 0 && (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                sx={{ cursor: "pointer" }}
                              >
                                <TableCell colSpan={showRatingColumn ? 6 : 5} align="center">
                                  No comments found.
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination
                        rowsPerPageOptions={[10, 20, 25, 100, 200]}
                        component="div"
                        count={isTexasNarrativeCL ? narrativeTotalCount : storeData?.commentLibraryListDataNnt?.pagination?.total_count}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        onPageChange={handleChangePage}
                        ActionsComponent={TablePaginationActions}
                      />
                    </Box>
                  </TabPanel>)}
                <TabPanel value={getActiveTabIndex(value)} index={tabIndexes.newComment} className="tab_panel_cLibrary">
                  <AddCommentModal
                    templateId={templateId}
                    categoryId={categoryId}
                    lineUuid={lineUuid}
                    editComment={editComment}
                    setEditComment={setEditComment}
                    recommendation={recommendation}
                    comment_dropdowns={comment_dropdowns}
                    prompt={prompt}
                    commentUuid={uuid}
                    is_mannual_prompt={is_mannual_prompt}
                    disableCommentBtn={disableCommentBtn}
                    setDisableCommentBtn={setDisableCommentBtn}
                    lineName={lineName}
                    categoryName={categoryName}
                    categoryUuid={categoryUuid}
                    setLineData={setLineData}
                    ratingValue={ratingValue}
                    setRatingValue={setRatingValue}
                    locationValue={locationValue}
                    setLocationValue={setLocationValue}
                    tag={tag}
                    setTag={setTag}
                    commentTitle={commentTitle}
                    editorContent={editorContent}
                    setEditorContent={setEditorContent}
                    setCommentTitle={setCommentTitle}
                    showCommentModal={showCommentModal}
                    selectedFilterTagID={selectedFilterTagID}
                    prefetchedTagList={prefetchedNewCommentTags}
                  />
                </TabPanel>
                <TabPanel value={getActiveTabIndex(value)} index={tabIndexes.aiDefectFinder} className="tab_panel_cLibrary">
                  <AIDefectFinder
                    loading={loading}
                    openData={openData}
                    medialLibery={medialLibery}
                    sideBarActive={storeData?.reportSideBarActive}
                    RenderContent={RenderContent}
                    handleImageUpload={handleImageUpload}
                    setMedialLibery={setMedialLibery}
                    storeData={storeData}
                    images={images}
                    handleRemoveImage={handleRemoveImage}
                    dataLoading={dataLoading}
                    setDataLoading={setDataLoading}
                    defaultSelect={defaultSelect}
                    datas={datas}
                    setDefaultSelect={handleSelect}
                    selectedContent={selectedContent}
                    setSelectedContent={setSelectedContent}
                    setDatas={setDatas}
                    handleRetry={handleRetry}
                    handleCheckbox={handleCheckbox}
                    handleSelect={handleSelect}
                    value={value}
                    selectedImages={selectedImages}
                    setSelectedImages={setSelectedImages}
                    onDragtoggle={onDragtoggle}
                    setOnDragToggle={setOnDragToggle}
                    selectedMediaFiles={selectedMediaFiles}
                    setSelectedMediaFiles={setSelectedMediaFiles}
                    type="non-narrative"
                    remainingImages={remainingImages}
                    promptUsed={tabValue}
                    manualPrompt={additionalInfo}
                    includeRecommendation={includeRecommendation}
                    categoryName={categoryName}
                    lineName={lineName}
                  />
                </TabPanel>
              </Box>
            </Grid>
          </Grid>)}
      </DialogContent>
      <Divider />
      <DialogActions className="comment-library-action">
        {value !== tabIndexes.aiDefectFinder && !editComment &&
          <div className={`comment-library-checkbox-container ${value === tabIndexes.commentLibrary ? "hidden" : "visible"}`}>
            {value === tabIndexes.newComment ? (
              <>
                {reportWriterSettingsAccess ?
                  <>
                    <FormGroup>
                      <FormControlLabel
                        className="cl_checkbox"
                        control={
                          <Checkbox
                            checked={addToLibrary}
                            onChange={() => setAddToLibrary(!addToLibrary)}
                            sx={{
                              height: "24px !important",
                              width: "24px !important",
                              marginRight: "8px",
                              "& .MuiSvgIcon-root": { height: "24px !important", width: "24px !important" },
                            }}
                          />
                        }
                        label="Save to comment library"
                      />
                    </FormGroup>
                    <FormGroup>
                      {storeData?.categoryLineRelation ? (
                        <FormControlLabel
                          className={"cl_checkbox"}
                          control={
                            <Checkbox
                              checked={addToTemplate}
                              onChange={() => setAddToTemplate(!addToTemplate)}
                              sx={{
                                height: "24px !important",
                                width: "24px !important",
                                marginRight: "8px",
                                "& .MuiSvgIcon-root": { height: "24px !important", width: "24px !important" },
                              }}
                            />
                          }
                          label="Add to template"
                        />
                      ) : (
                        <Tooltip
                          style={{ backgroundColorcolor: "white" }}
                          title={
                            <span
                              style={{
                                fontSize: "14px",
                                lineHeight: "17.5px",
                                width: "231px",
                                height: "67px",
                                borderRadius: "4px",
                                fontWeight: "400",
                              }}
                            >
                              Action Unavailable
                            </span>
                          }
                          arrow
                          placement="top"
                        >
                          <FormControlLabel
                            className={"disable_cl_checkbox"}
                            control={
                              <Checkbox
                                disabled
                                sx={{
                                  height: "24px !important",
                                  width: "24px !important",
                                  marginRight: "8px",
                                  "& .MuiSvgIcon-root": { height: "24px !important", width: "24px !important" },
                                }}
                              />
                            }
                            label="Add to template"
                          />
                        </Tooltip>
                      )}
                    </FormGroup>
                  </> : null}
              </>
            ) : null}
          </div>}
        <div className="">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            {(value === tabIndexes.aiDefectFinder && (loading || selectedContent)) && (
              <Typography
                variant="caption"
                className="open-sans-text"
                sx={{
                  color: '#777777',
                  maxWidth: 481,
                  verticalAlign: 'middle',
                  fontFamily: '"Open Sans", sans-serif !important',
                  fontSize: '11px !important',
                  fontWeight: '400 !important',
                  lineHeight: '100% !important',
                  letterSpacing: '0px !important',
                  display: 'inline-block',
                  textAlign: 'left'
                }}
              >
                <span className="open-sans-text">Comments generated by AI are intended to assist and may contain errors or inaccuracies.</span> <br />
                <span className="open-sans-text" style={{ marginTop: '4px', display: 'inline-block' }}>Please review and verify all content before submitting your report.</span>
              </Typography>
            )}
          </Box>
        </div>
        <div className="comment-library-action-btn">
          <Button className="cl-cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            disabled={
              value === tabIndexes.newComment
                ? (commentTitle?.trim() === "" &&
                  (editorContent?.innerHTML?.trim() === "" ||
                    editorContent?.innerHTML?.trim() === "<p><br></p>" ||
                    editorContent?.innerHTML?.trim() === "<br>" ||
                    preprocessHTMLContent(editorContent?.innerHTML) === ""))
                : value === tabIndexes.aiDefectFinder
                  ? (getButtonLabel() !== 'Analyze images' && checkedCount === 0) || images.length === 0 ||
                  disable ||
                  (images.length === 1 && (images[0].file.size > MAX_FILE_SIZE || !ALLOWED_TYPES.includes(images[0].file.type || images[0].type))) ||
                  !images.some((img) => {
                    const file = img.file || img;
                    const fileType = file.type || img.type;
                    const fileSize = file.size || img.size;
                    return (
                      fileSize <= MAX_FILE_SIZE &&
                      ALLOWED_TYPES.includes(fileType)
                    );
                  })
                  : value === tabIndexes.commentLibrary
                    ? Array.isArray(selected) && selected.length === 0
                    : false
            }
            className={getButtonLabel() === "Analyze images" ? "cl-analyze-btn" : "cl-add-btn"}
            onClick={() => {
              if (value === tabIndexes.newComment) {
                createNewComment(inspectionData, editorContent?.innerHTML, null, null)
              } else if (value === tabIndexes.aiDefectFinder) {
                return getButtonLabel() !== 'Analyze images'
                  ? handleAnalyseDefect()
                  : handleNext(false);
              } else if (value === tabIndexes.commentLibrary && Array.isArray(selected) && selected.length !== 0) {
                handleAddSelectedComment();
              } else {
                return null;
              }
            }}
          >
            {value === tabIndexes.aiDefectFinder && !selectedContent && !loading ? <Sparkle /> : ""}
            {getButtonLabel()}
          </Button>
        </div>
      </DialogActions>
    </Dialog >
  );
};

export default NonNarrativeCL;